export const isMobile = () => {
  return window.matchMedia('(max-width: 767px)').matches
}
export const isDesktop = () => {
  return window.matchMedia("(min-width: 1024px)").matches
}
export const isHD = () => {
  return window.matchMedia("(min-width: 1200px)").matches
}

export const getRandomId = () => {
  return `id_${Math.random().toString().slice(2)}`
}

/*const colorsPlaceholder = Object.freeze([
  '#005AD4',
  '#00AED4',
  '#00D48C',
  '#D4A900',
  '#D46400',
  '#B100D4',
  '#D40098'
])*/

/*export const getRandomPlaceholderColor = () => {
  return colorsPlaceholder[Math.floor(Math.random() * 7)]
}*/

export const getRandomPlaceholderImageUrl = () => {
  return `/static/images/placeholder-${Math.floor(Math.random() * 7)}.jpg`
}

export const getViewPortWidth = () => {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
}

export const getViewPortHeight = () => {
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
}

export const getTimeString = time => {
  const hour = parseInt(time / 3600, 10) % 24;
  const minute = parseInt(time / 60, 10) % 60;
  const seconds_long = time % 60;
  const seconds = seconds_long.toFixed();
  return (hour !== 0 ? hour + ':' : '') + (minute < 10 ? (hour !== 0 ? '0' : '') + minute : minute) + ':' + (seconds < 10 ? '0' + seconds : seconds);
}

export const localizeUrl = (language, url) => {
  return `${language && language !== 'da' ? '/' + language : ''}${url}`
}

export const isInternalLink = url => {
  if (!url) return url
  return Boolean(url.includes(window.location.host) || !url.includes('http'))
}

export const isExternalLink = url => !isInternalLink(url)

export const getPathFromAbsoluteUrl = url => {
  try {
    const urlObj = new URL(url)
    return `${urlObj.pathname}${urlObj.search}`
  } catch (error) {
    console.error(error);
    return ''
  }
  // if (!url || !url.includes(window.location.host)) return url
  // return url.split(window.location.host)[1]
}

export const secondsToMinutes = seconds => {
  const minutesToShow = Number(seconds) / 60
  const secondsToShow = Number(seconds) % 60
  const secondsFormatted = () => {
    if (!secondsToShow) return "00"
    if (secondsToShow < 10) return `0${secondsToShow}`
    return secondsToShow
  }
  return `${~~minutesToShow || '0'}:${secondsFormatted()}`
}

export const isSMKGuide = (currentRoute = {}) => currentRoute.section && currentRoute.section.name === 'SMK Guide'

export const isGuideLanding = (currentRoute = {}) => {
  const { id, smk_guide: guide = { landing_page: {} } } = currentRoute

  if (!guide.landing_page || !guide.landing_page.ID || !id)
    return false
  return guide.landing_page.ID === id
}

export const getFeaturedImageUrl = data => {
  const { media_details } = (data && data._embedded && data._embedded['wp:featuredmedia'][0]) || {}
  const { medium_large = {}, medium = {}, full = {} } = (media_details && media_details.sizes) || {}
  // large = {}
  
  if (!medium_large) {
    return medium ? (medium.source_url || '') : (full.source_url || '')
  }
  return medium_large.source_url || ''
}

export const _try = (fn, defaultVal) => {
  try {
    return fn()
  } catch (e) {
    return defaultVal
  }
}


// WEBPACK FOOTER //
// ./src/services/service-utils.js